import { getSiteConfig } from "@/config/siteConfigs";
import AGB from "./Agb";
import AgbCz from "./AgbCz";

const Terms = () => {
  const siteConfig = getSiteConfig();

  if (siteConfig.language === "cz") {
    return <AgbCz />;
  }

  return <AGB />;
};

export default Terms;
